function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-return-assign */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import moment from 'moment';
import { scaleTime, scaleLinear } from 'd3-scale';
import { area } from 'd3-shape';
import { max as maxFromD3 } from 'd3-array';
import significantDigitsFormat from "../utils/significant-digits-format";
import getTicks from "../utils/get-ticks";
import getAxisDates from "../utils/get-axis-dates";
import ChartYAxis from "./chart-y-axis";
import ChartXAxis from "./chart-x-axis";
import ChartGrid from "./chart-grid";
import ChartOverlayTrigger from "./chart-overlay-trigger";
import ChartRectClipPath from "./chart-rect-clip-path";
import ChartNoData from "./chart-no-data";
export var Graph =
/*#__PURE__*/
function (_Component) {
  _inherits(Graph, _Component);

  function Graph() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Graph);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Graph)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "getPoints", function (xScale, yScale, data, sourceType) {
      var _this$props = _this.props,
          xAxisKey = _this$props.xAxisKey,
          yAxisKey = _this$props.yAxisKey;
      var fn = area().x(function (d) {
        return xScale(moment(d[xAxisKey]).startOf('day'));
      }).y0(_this.props.height).y1(function (d) {
        return yScale(d[sourceType][yAxisKey]);
      });
      return fn(data);
    });

    _defineProperty(_assertThisInitialized(_this), "getXScale", function () {
      var _this$props2 = _this.props,
          width = _this$props2.width,
          xAxisOffset = _this$props2.xAxisOffset,
          days = _this$props2.days;
      var overflowOffset = 2;
      return scaleTime().domain([moment().startOf('day').subtract(days, 'days'), moment().startOf('day')]).range([0, width - xAxisOffset - overflowOffset]);
    });

    _defineProperty(_assertThisInitialized(_this), "getMaxYValue", function () {
      var MAX_EMPTY_Y_TICKS = 6;
      var _this$props3 = _this.props,
          data = _this$props3.data,
          sourceTypes = _this$props3.sourceTypes,
          yAxisKey = _this$props3.yAxisKey;
      var values = data.reduce(function (prev, item) {
        return [].concat(_toConsumableArray(prev), _toConsumableArray(sourceTypes.map(function (type) {
          return item[type][yAxisKey];
        })));
      }, []);
      var max = maxFromD3(values) * 1.1 || MAX_EMPTY_Y_TICKS;
      return max;
    });

    _defineProperty(_assertThisInitialized(_this), "getYScale", function () {
      var _this$props4 = _this.props,
          height = _this$props4.height,
          tooltipHeight = _this$props4.tooltipHeight;

      var max = _this.getMaxYValue();

      return scaleLinear().domain([0, max]).range([height, tooltipHeight]);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (_ref) {
      var clientX = _ref.clientX;

      if (_this._container) {
        var _this$props5 = _this.props,
            hoverOnDate = _this$props5.hoverOnDate,
            data = _this$props5.data,
            xAxisOffset = _this$props5.xAxisOffset,
            yAxisOffset = _this$props5.yAxisOffset,
            circleYOffset = _this$props5.circleYOffset,
            sourceTypes = _this$props5.sourceTypes,
            xAxisKey = _this$props5.xAxisKey,
            yAxisKey = _this$props5.yAxisKey,
            hoverType = _this$props5.hoverType;
        if (!data) return;

        var _this$_container$getB = _this._container.getBoundingClientRect(),
            leftPos = _this$_container$getB.left;

        var hoverPosition = clientX - leftPos;

        var xScale = _this.getXScale();

        var yScale = _this.getYScale();
        /**
         * Attempt to find closest date to hover place.
         */


        var x = xScale.invert(hoverPosition - xAxisOffset);

        var _data$reduce = data.reduce(function (result, item) {
          var date = moment(item[xAxisKey]).toDate();
          var diff = Math.abs(date - x);
          if (typeof result.diff === 'undefined' || result.diff > diff) return {
            diff: diff,
            closest: _objectSpread({}, item, {
              parsedDate: date
            })
          };
          return result;
        }, {}),
            closest = _data$reduce.closest;

        hoverPosition = xScale(closest.parsedDate) + xAxisOffset;
        var circles = sourceTypes.map(function (type) {
          var y = closest[type][yAxisKey];
          return {
            x: hoverPosition,
            y: yScale(y) + yAxisOffset - circleYOffset,
            type: type,
            value: y
          };
        });
        if (hoverType === 'accumulation') circles = circles.slice(0, 1);
        hoverOnDate(closest[xAxisKey]);

        _this.setState({
          hoverPosition: hoverPosition,
          hoverDate: closest.parsedDate,
          circles: circles
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      var hoverOnDate = _this.props.hoverOnDate;
      hoverOnDate(null);

      _this.setState({
        hoverPosition: null,
        hoverDate: null,
        circles: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCircles", function () {
      var _this$props6 = _this.props,
          circleRadius = _this$props6.circleRadius,
          hoverType = _this$props6.hoverType,
          xAxisOffset = _this$props6.xAxisOffset,
          width = _this$props6.width;
      var _this$state = _this.state,
          circles = _this$state.circles,
          hoverPosition = _this$state.hoverPosition;
      var allowedSpace = 20;
      var textAnchor = hoverPosition + xAxisOffset >= width - allowedSpace ? 'end' : 'start';
      return circles.map(function (circle, i) {
        if (!circle) return null;
        var x = circle.x,
            y = circle.y,
            value = circle.value;
        return React.createElement("g", {
          key: i
        }, React.createElement("circle", {
          cx: x,
          cy: y,
          className: "Circle",
          r: circleRadius
        }), hoverType === 'accumulation' && React.createElement("text", {
          x: x,
          y: y,
          className: "Circle-text",
          textAnchor: textAnchor,
          transform: "translate(".concat(textAnchor === 'start' ? 10 : -10, ", 0)")
        }, value));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderHoverPosition", function () {
      var _this$props7 = _this.props,
          height = _this$props7.height,
          yAxisOffset = _this$props7.yAxisOffset;
      var hoverPosition = _this.state.hoverPosition;
      if (!hoverPosition) return null;
      return React.createElement("g", null, React.createElement("line", {
        className: "HoverLine",
        x1: hoverPosition,
        x2: hoverPosition,
        y1: "0",
        y2: height + yAxisOffset
      }), _this.renderCircles());
    });

    return _this;
  }

  _createClass(Graph, [{
    key: "renderArea",
    value: function renderArea(points, index) {
      return React.createElement("g", {
        className: "ChartArea",
        key: index
      }, React.createElement("path", {
        fill: this.props.colors[index],
        className: "ChartAreaPath",
        d: points
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props8 = this.props,
          data = _this$props8.data,
          isLoading = _this$props8.isLoading,
          days = _this$props8.days,
          height = _this$props8.height,
          width = _this$props8.width,
          xAxisOffset = _this$props8.xAxisOffset,
          yAxisOffset = _this$props8.yAxisOffset,
          hoverSpotOffset = _this$props8.hoverSpotOffset,
          sourceTypes = _this$props8.sourceTypes,
          xAxisDateFormatHover = _this$props8.xAxisDateFormatHover,
          noDataText = _this$props8.noDataText;
      var _this$state2 = this.state,
          hoverPosition = _this$state2.hoverPosition,
          hoverDate = _this$state2.hoverDate;
      var lines = [];
      var xScale = this.getXScale();
      var yScale = this.getYScale();
      var yProps = {
        ticks: yScale.ticks(5),
        scale: yScale,
        x: 0,
        y: yAxisOffset,
        width: width,
        height: height,
        tickWidth: width,
        tickFormat: significantDigitsFormat
      };
      var xProps = {
        height: height,
        hover: hoverPosition && {
          hoverPosition: hoverPosition,
          hoverText: moment(hoverDate).format(xAxisDateFormatHover)
        },
        ticks: getAxisDates(days, getTicks(days)),
        width: width,
        xAxisOffset: xAxisOffset,
        scale: xScale,
        yAxisOffset: 0,
        dateFormat: this.props.xAxisDateFormat
      };
      var gridProps = {
        xTicks: getAxisDates(days, getTicks(days)),
        yTicks: yScale.ticks(5),
        xScale: xScale,
        yScale: yScale,
        xOffset: xAxisOffset,
        yOffset: yAxisOffset,
        width: width,
        height: height
      };
      var overlayProps = {
        className: 'HoverSpot',
        x: xAxisOffset - hoverSpotOffset,
        y: -yAxisOffset,
        width: width,
        height: height,
        onMouseMove: this.handleMouseMove,
        onMouseLeave: this.handleMouseOut
      };
      /* eslint-disable curly */

      if (data && data.length && width) {
        lines = sourceTypes.map(function (type, i) {
          var points = _this2.getPoints(xScale, yScale, data, type);

          return _this2.renderArea(points, i);
        });
      }

      return React.createElement("g", {
        className: "Graph",
        ref: function ref(c) {
          return _this2._container = c;
        }
      }, React.createElement(ChartRectClipPath, {
        id: "clip",
        width: width,
        height: height,
        y: -yAxisOffset
      }), React.createElement("g", {
        transform: "translate(0, ".concat(yAxisOffset, ")"),
        style: {
          clipPath: 'url(#clip)'
        }
      }, React.createElement(ChartGrid, gridProps)), React.createElement(ChartYAxis, yProps), React.createElement(ChartXAxis, xProps), !isLoading && React.createElement("g", null, React.createElement("g", {
        transform: "translate(".concat(xAxisOffset, ", ").concat(yAxisOffset, ")"),
        style: {
          clipPath: 'url(#clip)'
        }
      }, lines), this.renderHoverPosition(), !lines.length && React.createElement(ChartNoData, {
        height: height,
        width: width,
        noDataText: noDataText
      })), !isLoading && data && data.length > 0 && React.createElement(ChartOverlayTrigger, overlayProps));
    }
  }]);

  return Graph;
}(Component);

_defineProperty(Graph, "propTypes", {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  days: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  hoverOnDate: PropTypes.func.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
  xAxisOffset: PropTypes.number,
  yAxisOffset: PropTypes.number,
  circleYOffset: PropTypes.number,
  leftTooltipOffset: PropTypes.number,
  topTooltipOffset: PropTypes.number,
  circleRadius: PropTypes.number,
  tooltipHeight: PropTypes.number,
  hoverSpotOffset: PropTypes.number,
  xAxisKey: PropTypes.string,
  yAxisKey: PropTypes.string,
  noDataText: PropTypes.string,
  sourceTypes: PropTypes.array.isRequired,
  colors: PropTypes.array,
  xAxisDateFormat: PropTypes.string,
  xAxisDateFormatHover: PropTypes.string,
  hoverType: PropTypes.string
});

_defineProperty(Graph, "defaultProps", {
  height: 400,
  xAxisOffset: 50,
  yAxisOffset: -25,
  circleYOffset: 2,
  leftTooltipOffset: 3,
  topTooltipOffset: 15,
  circleRadius: 6,
  tooltipHeight: 25,
  hoverSpotOffset: 8,
  xAxisKey: 'x',
  yAxisKey: 'y',
  noDataText: '-',
  colors: ['#4B3DA3', '#419B86', '#026EAD'],
  xAxisDateFormat: 'MMM D',
  xAxisDateFormatHover: 'dddd, MMMM D',
  hoverType: 'accumulation'
});

export default Graph;